import { useEffect, useState } from "react";

import {
  Flex,
  Heading,
  Image,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import DiscountFilterMasterTable from "../../components/DiscountFilterMasterTable/DiscountFilterMasterTable";
import {
  REQUEST_MASTER_DISCOUNT_FILTER,
  REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES,
} from "../../store/discountfilter/discountfilterActionTypes";
import { useDiscountFilterMaster } from "../../store/discountfilter/reducer";

const DiscountFilter = () => {
  const { masterFaqsCat, busy, masterFaqs } = useDiscountFilterMaster();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: REQUEST_MASTER_DISCOUNT_FILTER });
    dispatch({ type: REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [searchQuery, setSearch] = useState("");

  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Manage Discount filter
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="https://bit.ly/dan-abramov"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <DiscountFilterMasterTable query={searchQuery} />
    </>
  );
};

export default DiscountFilter;
